/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneJwVideoArticle as ResolvedStandaloneJwVideoArticle } from 'base/components/standalone/JwVideo/Article';

export const JwVideoArticle: typeof ResolvedStandaloneJwVideoArticle = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneJwVideoArticle {...props} />
        </ErrorBoundary>
    );
});

export type JwVideoArticleProps = PropsFromComponent<typeof JwVideoArticle>;

/** @deprecated Use slot architecture instead */
export const JwVideoArticleWith = (extras: DynamicStandaloneExtras): typeof JwVideoArticle => {
    return function JwVideoArticle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'JwVideoArticle');
        return <ResolvedStandaloneJwVideoArticle {...mergeProps({ options: { theme } }, props)} />;
    }
}